import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../Navbar/Navbar";
import "./DailyUpdateApproval.css";
import DatePicker from "react-datepicker";
import { format, startOfMonth } from "date-fns";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import {
  dailyUpdateAdd,
  dailyUpdateList,
} from "../../Redux/DailyUpdate/Action";
import { FaEye } from "react-icons/fa";
import { BiSolidMessageRoundedDetail } from "react-icons/bi";
import Swal from "sweetalert2";
import { getTaskDetails } from "../../Redux/Task/Action";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";
import Icon from "../utility/Icon";

const DailyUpdateApproval = () => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
  const [toDate, setToDate] = useState(new Date());
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const { dailyUpdateDetails } = useSelector((store) => store.dailyUpdate);
  const [comment, setComment] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const handleCloseViewModal = () => setShowViewModal(false);
  const handleCloseCommentModal = () => setShowCommentModal(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const [dailyUpdateData, setdailyUpdateData] = useState({
    dailyemployeeupdateId: "",
    date: "",
    inTime: "",
    outTime: "",
    name: "",
    todaytask: "",
    tomorrowtask: "",
    workdescription: "",
    createdDate: "",
    comment: "",
    remark: "",
    status: "",
    actionType: "list",
  });

  useEffect(() => {
    dispatch(empList(token));
  }, [dispatch, token]);

  const options = useMemo(
    () => [
      { value: 0, label: "ALL" }, // Static option
      ...emplists.map((emp) => ({
        value: emp.loginId,
        label: `${emp.firstName} ${emp.lastName}`,
      })),
    ],
    [emplists]
  );
  useEffect(() => {
    if (options.length > 0 && selectedEmployee === null) {
      setSelectedEmployee(options[0]);
    }
  }, [options, selectedEmployee]);

  useEffect(() => {
    fetchData(pageNumber-1,pageSize);
  }, [dispatch, fromDate, toDate, selectedEmployee, pageSize, pageNumber]);

  const fetchData = (pageNumber,pageSize) => {
    if (selectedEmployee) {
      const formattedFromDate = format(fromDate, "yyyy-MM-dd");
      const formattedToDate = format(toDate, "yyyy-MM-dd");
      dispatch(
        dailyUpdateList(
          formattedFromDate,
          formattedToDate,
          selectedEmployee.value,
          token,
          pageSize,
          pageNumber
        )
      );
    }
  };


  const handleEmpChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };

  useEffect(() => {
    if (dailyUpdateDetails.dailyEmployeeDetails && dailyUpdateDetails.dailyEmployeeDetails.length > 0) {
      setdailyUpdateData((prevData) => ({
        ...prevData,
        ...dailyUpdateDetails.dailyEmployeeDetails[0],
      }));
    }
  }, [dailyUpdateDetails]);

  const handleFromDateChange = (e) => {
    setFromDate(new Date(e.target.value));
  };

  const handleToDateChange = (e) => {
    setToDate(new Date(e.target.value));
  };




  const renderInOutTimes = (row) => (
    <div>
      <div>{row.inTime}</div>
      <div>{row.outTime}</div>
    </div>
  );

  const [selectedRow, setSelectedRow] = useState(null);
  const handleOpenViewModal = (row) => {
    setSelectedRow(row);
    setShowViewModal(true);
  };

  const handleOpenCommentModal = (row) => {
    setSelectedRow(row);
    setShowCommentModal(true);
  };

  const handleSubmit = (status) => {
    if (comment.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Comment is required",
        text: "Please enter a comment before submitting.",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Add it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedRow = {
          dailyemployeeupdateId: selectedRow.dailyemployeeupdateid,
          status: status,
          actionType: "APPROVE",
          ...(status === "Y" && { remark: comment.trim(), comment: "" }),
          ...(status === "C" && { comment: comment.trim(), remark: "" }),
        };
        dispatch(dailyUpdateAdd(updatedRow, token))
          .then(({ success, error }) => {
            if (success) {
              const formattedFromDate = format(fromDate, "yyyy-MM-dd");
              const formattedToDate = format(toDate, "yyyy-MM-dd");
              dispatch(
                dailyUpdateList(
                  formattedFromDate,
                  formattedToDate,
                  selectedEmployee.value,
                  token,
                  pageSize,
                  pageNumber-1
                )
              );
              handleCloseViewModal();
              setComment("");
              Swal.fire({
                icon: "success",
                title: status === "Y" ? "Approved!" : "Commented!",
                text: `Your ${
                  status === "Y" ? "approval" : "comment"
                } has been recorded.`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else if (error) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error || "Something went wrong!",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong during submission!",
            });
          });
      }
    });
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };
  const columns = [
    // {
    //   name: "Sn",
    //   selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
    //   sortable: false,
    //   width: "100px",
    // },
    {
      name: "Date",
      selector: (row) => row.createdDate,
      sortable: true,
    },
    {
      name: "In/Out Time",
      selector: (row) => row,
      sortable: true,
      cell: renderInOutTimes,
    },
    {
      name: "Project",
      selector: (row) => row.projectCode,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Task",
      selector: (row) => row.taskNo,
      sortable: true,
    },
    {
      name: "Today's Task",
      selector: (row) => row.todaytask,
      sortable: true,
    },
    {
      name: "Tomorrow's Task",
      selector: (row) => row.tomorrowtask,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Time Stamp",
    //   selector: (row) => row.createdDate,
    //   sortable: true,
    // },
    // {
    //   name: "Status",
    //   selector: (row) => row.status,
    //   sortable: false,
    // },
    {
      name: "Status",
      selector: (row) => {
        switch (row.status) {
          case "Y":
            return "Approved";
          case "N":
            return "Not Approved";
          case "C":
            return "Commented";
          default:
            return "Unknown Status";
        }
      },
      sortable: false,
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      cell: (row) => (
        // <div>
        //   <button
        //     className="btn btn-primary btn-sm"
        //     onClick={() => handleOpenViewModal(row)}
        //   >
        //     {" "}
        //     <BiSolidMessageRoundedDetail />
        //   </button>
        //   <button
        //     className="btn btn-secondary btn-sm ms-1"
        //     onClick={() => handleOpenCommentModal(row)}
        //   >
        //     <FaEye />
        //   </button>
        // </div>
        <div>
          {/* Comment Button with Tooltip */}
 
<Icon
  icon={BiSolidMessageRoundedDetail}
  variant="primary"
  title="Add Comment"
  onClick={() => handleOpenViewModal(row)}
/>

<Icon
  icon={FaEye}
  variant="secondary"
  title="Overview"
  className="ms-1"           // keep Bootstrap spacing utilities
  onClick={() => handleOpenCommentModal(row)}
/>
          {/* Overview Button with Tooltip */}
    
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: " rgb(46 112 202)",
        color: "white",
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
  };

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
      <div className="container-fluid mt-4">
        <div>
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">Employee :</label>
              </b>
            </div>
            <div className="col-sm-4">
              <Select
                options={options}
                value={selectedEmployee}
                onChange={handleEmpChange}
                placeholder="Select Employee"
                isClearable
              />
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">From Date :</label>
              </b>
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <DatePicker
                  selected={fromDate}
                  onChange={(newValue) => {
                    setFromDate(newValue);
                  }}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  onKeyDown={(event) => event.preventDefault()}
                />
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">To Date :</label>
              </b>
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <DatePicker
                  selected={toDate}
                  onChange={(newValue) => {
                    setToDate(newValue);
                  }}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  onKeyDown={(event) => event.preventDefault()}
                  minDate={fromDate}
                />
            </div>
          </div>
        </div>

        <div className="card3">
          <div className="card-body">

            <NewGlobalDataTable
               columns={columns} 
               data={dailyUpdateDetails.dailyEmployeeDetails} 
               tableName={'DAILYUPDATE APPROVALS'} 
               setPageSize={setPageSize} 
               setPageNumber={setPageNumber}
               totalRecord={dailyUpdateDetails.totalRecord} 
            />

            {/* First Modal: View Details */}
            {showViewModal && <div className="modal-backdrop fade show"></div>}
            <div
              className={`modal fade ${showViewModal ? "show d-block" : ""}`}
              tabIndex="-1"
              role="dialog"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Update Comment</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleCloseViewModal}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label htmlFor="viewFormId" className="form-label">
                          <b>Comment:</b>
                        </label>
                        <textarea
                          id="viewFormId"
                          className="form-control textarea"
                          rows="5"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      </div>
                      <div className="d-flex justify-content-center mt-3 gap-3">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => handleSubmit("Y")}
                        >
                          APPROVE
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => handleSubmit("C")}
                        >
                          COMMENT
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* Second Modal: Comment Details */}
            {showCommentModal && (
              <div className="modal-backdrop fade show"></div>
            )}
            <div
              className={`modal fade ${showCommentModal ? "show d-block" : ""}`}
              tabIndex="-1"
              role="dialog"
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Comments/Remarks</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleCloseCommentModal}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    {selectedRow ? (
                      <div>
                        <div>
                          <strong>Work Description :</strong>{" "}
                          {selectedRow.workdescription ||
                            "No Description Added"}
                        </div>
                        <hr />
                        <div>
                          <strong>Comment :</strong>{" "}
                          {selectedRow.comment || "No Comment Added"}
                        </div>
                        <hr />
                        <div>
                          <strong>Remark :</strong>{" "}
                          {selectedRow.remark || "No Remark Added"}
                        </div>
                        <hr />
                      </div>
                    ) : (
                      <div>No Data Available</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
  );
};

export default DailyUpdateApproval;
